import { Typography } from "@mui/material";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export interface StackedBarChartProps {
  stackedChartResponse: {
    message: string;
    type: string;
    chartData: Array<{ [key: string]: any }>;
  };
}

const StackedBarChart: React.FC<StackedBarChartProps> = ({
  stackedChartResponse,
}) => {
  const { chartData } = stackedChartResponse;

  const barKeys = chartData[0]
    ? Object.keys(chartData[0]).filter((key) => key !== "name")
    : [];

  // Generate a random color for each bar (you can customize this)
  const generatePurpleThemeColor = () => {
    const darkPurples = [
      "#6A0DAD", // Deep Purple
      "#7B1FA2", // Dark Orchid
      "#8E24AA", // Strong Purple
      "#9C27B0", // Vibrant Purple
      "#AB47BC", // Medium Lavender
    ];
    return darkPurples[Math.floor(Math.random() * darkPurples.length)];
  };

  return (
    <>
      <ResponsiveContainer width={"100%"} height={300}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {/* Dynamically create Bar components for each data key */}
          {barKeys?.map((key, index) => (
            <Bar
              key={index}
              dataKey={key}
              stackId="a"
              fill={generatePurpleThemeColor()} // Or use a specific color scheme
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default StackedBarChart;
